import { useDispatch } from 'react-redux';

import { toast } from '../../../util/toast';
import { useDeletePaylinkCustomerMutation, mmsApi } from '../../../store/modules/merchant/api';

export const useCustomerDelete = (customerId: string) => {
  const [deletePaylinkCustomer, { isLoading }] = useDeletePaylinkCustomerMutation();
  const dispatch = useDispatch();

  const onCustomerDelete = async () => {
    try {
      await deletePaylinkCustomer(customerId).unwrap();

      // let delete go through before refetching
      setTimeout(() => {
        dispatch(mmsApi.util.invalidateTags([{ type: 'Customer', id: customerId }]));
      }, 100);
    } catch (err) {
      const errorMessage =
        'Something went wrong while deleting the customer, please try again later';
      toast.error(errorMessage);
      throw err;
    }

    toast.success('Customer successfully deleted.');
  };

  return {
    onCustomerDelete,
    isLoading,
  };
};
